import {Component} from '@angular/core';

@Component({
    selector: 'my-app',
    template: `
        <app-index></app-index>
    `
})
export class AppComponent {}



// WEBPACK FOOTER //
// ./assets_dev/ts/app/app.component.ts